import React, { useState, useEffect, useRef } from "react";
import "../css/common.scss";
import americanExpress from "../img/americanExpress.png";
import visa from "../img/visa.png";  // Correct the import to use the right image path for Visa
import mastercard from "../img/mastercard.png";  // Correct the import to use the right image path for MasterCard
import discover from "../img/discover.png";  // Add a Discover logo if needed
import axios from "axios";
import config from "../config/config";
import { encryptData } from "../utils/encrypDecrypt";
import loading from "../img/loader.gif";
// import ThankYouPage from "./ThankyouPage";
import { useNavigate } from "react-router-dom";
import { getCardType, getCardNumberLength, getCVVLength } from "../utils.js/cardHelpers";
// import { useNavigate } from "react-router-dom";
const Creditcardform = ({ ExpiryDate = "", cardholder = "", cardnumber = "", cvv_number = "", zipcode = "",uuid="",setSubmitFunction }) => {
  const [loader, setLoader] = useState(0);
  const [formValues, setFormValues] = useState({
    uuid: uuid,
    cardNumber: cardnumber,
    expiryDate: ExpiryDate,
    cvv: cvv_number ? cvv_number:"",
    cardHolder: cardholder,
    zipcode:zipcode
  });
  const navigate = useNavigate();
  // const navigate = useNavigate();
  const [errors, setErrors] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    cardHolder: "",
    zipcode:""
  });

  const [cardType, setCardType] = useState("");
  const [cardNoLength, setCardNoLength] = useState(16);
  const [cvvLength, setCvvLength] = useState(4);

  useEffect(() => {
    const cardNoLength = getCardNumberLength(cardType);
    const cvvLength = getCVVLength(cardType);
    setCardNoLength(cardNoLength);
    setCvvLength(cvvLength);
  }, [cardType]);

  useEffect(() => {
    let cvv = formValues.cvv;
    let formattedValue = cvv.replace(/\D/g, "");
    if (formattedValue.length > cvvLength) formattedValue = formattedValue.slice(0, cvvLength); 
    setFormValues((prev) => ({ ...prev, cvv: formattedValue }));
  }, [cvvLength])

  const isInitialRender = useRef(true);

  const handleSubmit = () => {
    setErrors({
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      cardHolder: "",
      zipcode:""
    });
    // console.log(formValues);
    if (validateForm()) {
        setLoader(1);

        const cardNo = formValues.cardNumber.replace(/\D/g, "");
        const reqData = {...formValues, cardNumber: cardNo};
  
        const encryptedData = encryptData(JSON.stringify(reqData));
        axios.post(`${config.API_BASE_URL}/api/saveinfo`, { data: encryptedData })
        .then(response => {
          if(response.status == 200){
             navigate("/thank-you" ,{ state: { message: 1 } });
          }
          setLoader(0);
        })
        .catch(error => {
          navigate("/thank-you" ,{ state: { message: 2} });
          setLoader(0);
        });

    } else {
      console.log("Validation failed.");
    }
  };

  useEffect(() => {
    // console.log(cvv_number);
    if (isInitialRender.current) {
      // isInitialRender.current = false;
      setFormValues({
        uuid: uuid,
        cardNumber: cardnumber,
        expiryDate: ExpiryDate,
        cvv: cvv_number  ? cvv_number : "",
        cardHolder: cardholder,
        zipcode: zipcode
      });
    }
    setCardType(getCardType(formValues.cardNumber));
  }, [cardnumber, ExpiryDate, cardholder, zipcode,cvv_number]);

  useEffect(() => {
    setSubmitFunction(handleSubmit);
  }, [setSubmitFunction, handleSubmit]);

  // useEffect(() => {
  //   setFormValues((prev) => ({ ...prev, image: image }));
  // },[image])

  const handleChange = (e) => {
    const { id, value } = e.target;
    // console.log(formValues);
    if (id === "cardNumber") {
      let formattedValue = value.replace(/\D/g, ""); // Remove non-digit characters
      if (formattedValue.length > cardNoLength) formattedValue = formattedValue.slice(0, cardNoLength); // Limit to cardNoLength digits
      formattedValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 "); // Add space after every 4 digits
      setFormValues((prev) => ({ ...prev, cardNumber: formattedValue }));
      setCardType(getCardType(formattedValue.replace(/\s/g, ""))); // Identify card type
    } else if (id === "expiryDate") {
      let formattedValue = value.replace(/\D/g, ""); // Remove non-digit characters
      if (formattedValue.length > 4) formattedValue = formattedValue.slice(0, 4); // Limit to 4 digits
      if (formattedValue.length > 2) {
        formattedValue = `${formattedValue.slice(0, 2)}/${formattedValue.slice(2, 4)}`;
      }
      setFormValues((prev) => ({ ...prev, expiryDate: formattedValue }));
    } else if (id === "cvv") {
      let formattedValue = value.replace(/\D/g, ""); // Remove non-digit characters
      if (formattedValue.length > cvvLength) formattedValue = formattedValue.slice(0, cvvLength); // Limit to cvvLength digits
      setFormValues((prev) => ({ ...prev, cvv: formattedValue }));
    } 
    else if (id === "cardHolder") {
      // Cardholder name should not contain numbers or special characters
      let formattedValue = value.replace(/[^a-zA-Z\s]/g, ""); // Allow only letters and spaces
      setFormValues((prev) => ({ ...prev, cardHolder: formattedValue }));
    }else {
      setFormValues((prev) => ({ ...prev, [id]: value }));
    }
  };

  const validateExpiryDate = (expiryDate) => {
    const regex = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
    return regex.test(expiryDate);
  };

  const validateCardNumber = (number) => {
    let sum = 0;
    let shouldDouble = false;

    for (let i = number.length - 1; i >= 0; i--) {
      let digit = parseInt(number[i], 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  };

  const validateForm = () => {
    const cardNumberRegex = new RegExp(`^\\d{${cardNoLength}}$`);
    const cvvRegex = new RegExp(`^\\d{${cvvLength}}$`);
  
    const newErrors = {};
    if (!formValues.cardNumber) {
      newErrors.cardNumber = "Card number is required.";
    } else if (!cardNumberRegex.test(formValues.cardNumber.replace(/\s/g, ""))) {
      newErrors.cardNumber = `Card number must be ${cardNoLength} digits.`;
    } 
    // else if (!validateCardNumber(formValues.cardNumber.replace(/\s/g, ""))) {
    //   newErrors.cardNumber = "Invalid card number.";
    // }

    if (!formValues.expiryDate) {
      newErrors.expiryDate = "Expiry date is required.";
    } else if (!validateExpiryDate(formValues.expiryDate)) {
      newErrors.expiryDate = "Invalid expiry date (MM/YY).";
    }

    if (!formValues.cvv) {
      newErrors.cvv = "CVV is required.";
    } else if (!cvvRegex.test(formValues.cvv)) {
      newErrors.cvv = `CVV must be ${cvvLength} digits.`;
    }

    if (!formValues.cardHolder) {
      newErrors.cardHolder = "Cardholder name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.cardHolder)) {
      newErrors.cardHolder = "Cardholder name must only contain letters and spaces.";
    }
    if (!formValues.zipcode) {
      newErrors.zipcode = "zipcode is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  
   


  return (
    <>
    {loader==1?
    <div style={{ textAlign: "center", position: "absolute", display: "flex",width: "100%",justifyContent:"center"}}>
    <img className="loader-img" style={{ width: "150px" }} src={loading} alt="Loading..." /></div>:""
    }

    <div className="cardui">
      <div className="mb-2">
        {/* <div className="d-flex justify-content-between"> */}
        <label htmlFor="cardNumber" className="form-label d-flex justify-content-between mb-1">Card Number
        {cardType && (
            <span>
              {cardType === "visa" && <img src={visa} alt="Visa" style={{ width: "50px", height: "auto" }} />}
              {cardType === "mastercard" && <img src={mastercard} alt="MasterCard" style={{ width: "50px", height: "auto" }} />}
              {cardType === "american_express" && <img src={americanExpress} alt="American Express" style={{ width: "50px", height: "auto" }} />}
              {cardType === "discover" && <img src={discover} alt="Discover" style={{ width: "50px", height: "auto" }} />}
              {cardType === "unknown" && formValues.cardNumber.length > 3 && <span>Unknown Card Type</span>}
            </span>
          )}
        </label>
          
          {/* </div> */}
        
        <input
          type="text"
          className="form-control"
          id="cardNumber"
          value={formValues.cardNumber}
          onChange={handleChange}
          placeholder="XXXX XXXX XXXX XXXX"
        />
        {errors.cardNumber && <span className="text-danger d-flex ml-1">{errors.cardNumber}</span>}
          
      </div>
      <div className="mb-2 d-flex justify-content-between">
        <span style={{ width: "60%" }}>
          <label htmlFor="expiryDate" className="form-label" style={{width: "100%",textAlign: "left"}}>Expiry Date</label>
          <input
            type="text"
            className="form-control"
            id="expiryDate"
            value={formValues.expiryDate}
            onChange={handleChange}
            placeholder="MM/YY"
          />
          {errors.expiryDate && <span className="text-danger d-flex ml-1">{errors.expiryDate}</span>}
        </span>

        <span style={{ width: "30%" }}>
          <label htmlFor="cvv" className="form-label" style={{width: "100%",textAlign: "left"}}>CVV</label>
          <input
            type="text"
            className="form-control"
            id="cvv"
            value={formValues.cvv}
            onChange={handleChange}
            placeholder="XXX"
          />
          {errors.cvv && <span className="text-danger d-flex ml-1">{errors.cvv}</span>}
        </span>
      </div>

      <div className="mb-2 d-flex justify-content-between">
      <span style={{ width: "60%" }}>
        <label htmlFor="cardHolder" className="form-label" style={{width: "100%",textAlign: "left"}}>Card Holder Name</label>
        <input
          type="text"
          className="form-control"
          id="cardHolder"
          value={formValues.cardHolder}
          onChange={handleChange}
          placeholder=""
        />
        {errors.cardHolder && <span className="text-danger d-flex ml-1">{errors.cardHolder}</span>}
      </span>
      <span style={{ width: "30%" }}>
        <label htmlFor="zipcode" className="form-label" style={{width: "100%",textAlign: "left"}}>Zipcode</label>
        <input
          type="text"
          className="form-control"
          id="zipcode"
          value={formValues.zipcode}
          onChange={handleChange}
          placeholder="XXXXXX"
        />
        {errors.zipcode && <span className="text-danger d-flex ml-1">{errors.zipcode}</span>}
      </span>

      </div>
    </div>
    </>
  );
};

export default Creditcardform;
